module.exports = __webpack_public_path__ + "static/media/vista_lista.356fd07e.svg";